import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        if (r.data?.workspace_ids?.length && !localStorage.getItem("workspace_id")) {
          localStorage.setItem("workspace_id", r.data.workspace_ids[0]);
        }
      })
      .catch(() => {
        localStorage.removeItem("token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    if (data.user?.workspace_ids?.length) {
      localStorage.setItem("workspace_id", data.user.workspace_ids[0]);
    }
    setUser(data.user);
    return data.user;
  };

  const applyAuth = (data) => {
    localStorage.setItem("token", data.token);
    if (data.user?.workspace_ids?.length) {
      localStorage.setItem("workspace_id", data.user.workspace_ids[0]);
    }
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("workspace_id");
    setUser(false);
    window.location.href = "/login";
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, refreshUser, setUser, applyAuth }}>
      {children}
    </AuthContext.Provider>
  );
}
